
import Carousel from "../components/carousel";
import ProductItemColorSwatch from "../components/product-item-color-swatch"

export default class ProductRecommendationsSection{
    constructor(container) {
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (this.options['useRecommendations']) {
        this._loadRecommendations().then(this._createSlideshow.bind(this));
      } else {
        this._createSlideshow();
      }
    }
    onUnload() {
      this.carousel.destroy();
    } 
    _loadRecommendations() {
      var _this52 = this;

      var url = '/recommendations/products?section_id=product-recommendations&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsCount'];
      
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          _this52.element.querySelector('.recommendations').innerHTML = container.querySelector('.recommendations').innerHTML;
        });
      }); 
    }

    _createSlideshow() {
      this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]'));

      // Setup product item color swatch
      //new __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__["default"](this.element);
    }

}